import {sQuery as sq} from './sq.js';

let name = 'sQuery - Native Speed jQuery for Svelte/SolidJS'

let loadProc = function( bDoc = true ){
	sq('body').hide().fadeIn(400)

	if ( bDoc ){
		window.setDocTitle = (v, ot)=>{
			let c = sq('.cF[name="'+v+'"]').siblings().filter('.cSub').text()
			if ( !c )
				return
	
			let title = ot + ' - sQuery Docs'
			if (window.history.replaceState)
				window.history.replaceState({n:v}, title, './?n='+v+'#/docs' )
			document.title = title
			
			let h = '<a class="cWhite" href="./#/docs">Docs</a> -> <a class="cWhite" href="./?n='+c.replace(/ /g,'')+'#/docs">' 
				+ c + '</a> -> <a class="cWhite" href="./?p&n='+v+'#/docs">' + sq('.cF[name='+v+']').text().replace('・','') +'</a>'
			sq('#idDocNav').html(h)
			sq('.cF').removeClass('active')
			sq('.cF[name="'+v+'"]').addClass('active')
		}
	} else {
		window.setDocTitle = (v, ot)=>{
			let c = sq('.cF[name="'+v+'"]').siblings().filter('.cSub').text()
			if ( !c )
				return
	
			let title = ot + ' - sQuery Install'
			if (window.history.replaceState)
				window.history.replaceState({n:v}, title, './?n='+v+'#/install' )
			document.title = title
			
			let h = '<a class="cWhite" href="./#/install">Install</a> -> <a class="cWhite" href="./?n='+c.replace(/ /g,'')+'#/install">' 
				+ c + '</a> -> <a class="cWhite" href="./?p&n='+v+'#/install">' + sq('.cF[name='+v+']').text().replace('・','') +'</a>'
			sq('#idDocNav').html(h)
			sq('.cF').removeClass('active')
			sq('.cF[name="'+v+'"]').addClass('active')
		}
	}

	sq(document).onf('click', '.menu__toggler', function(){
		let el = sq('.menu__toggler')
		el.toggleClass('active')
		if ( sq('.menu__toggler').hasClass('active') )
			sq('#idLeft').fadeIn(500).animate([{left:"-200px"}, {left:"0px"}], 300)
		else	
			sq('#idLeft').fadeOut(500).animate([{left:"0px"}, {left:"-200px"}], 300)
		
		return false
	})
	sq('.cF').on('click', function(){
		let t = sq(this).attr('name')
		sq('doc[name="'+t+'"]').scrollToElement()
	})
	setTimeout(()=>{
		sq(document).on('scroll', function(){
			let isOnScreen = function(element){
				let curPos = element.offset(),
					curTop = curPos.top - sq('body').scrollTop(),
					screenHeight = sq('body').height();
				return (curTop > screenHeight) ? false : true;
			}
	
			let el
			sq('doc').each(function(){
				if ( isOnScreen( sq(this) ) )
					el = sq(this)
			})
			if ( el )
			{
				let ot = sq('.cF[name="'+el.attr('name')+'"]').text()
				window.setDocTitle( el.attr('name'), ot )
			}
		})
	},2500)
	
	window.clearDS = ()=> {
		sq('#idDS').val('')
		sq('#idDSC').fadeOut()
		sq('.cF').fadeIn()
		sq('.cF').each(function(){
			sq(this).html(sq(this).text())
		})
	}
	sq('#idDS').on('keyup', function(){
		let v = sq(this).val().trim()
		//console.log(v)
		sq('.cF').show()
		sq('.cF').each(function(){
			let t = sq(this).text(), lt = t.toLowerCase(), lv = v.toLowerCase()
			if ( lt.toLowerCase().includes(lv) )
				sq(this).html( t.replace(new RegExp(v, 'i'), "<b>$&</b>") )
			else
				sq(this).hide()
		})
		if ( sq(this).val() != '' )
		sq('#idDSC').show()
	}).on('blur', function(){
		if ( sq(this).val() == '' )
			window.clearDS()
	})
	sq('#idDSC').on('click',function(){
		window.clearDS()
	})
	setTimeout(function(){
		function qs(key) {
			key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
			let match = location.search.match(new RegExp("[?&]"+key+"=([^&]+)(&|$)"));
			return match && decodeURIComponent(match[1].replace(/\+/g, " "));
		}
		const n = qs('n') 
		if ( n )
			document.querySelector(`doc[name="${n}"]`).scrollIntoView()
	}, 1000)
}


export {name, loadProc}